export const chargeServicesDrawer = {
  title: "Costi e servizi",
  closeAria: "Chiudi",
  subtitle: {
    catalog: "Catalogo riutilizzabile per le tue fatture",
    select: "Seleziona gli elementi che vuoi aggiungere",
  },
  searchPlaceholder: "Cerca servizio…",
  createService: "Crea servizio",
  loading: "Caricamento dei servizi…",
  empty: "Non hai ancora alcun servizio. Crea il tuo primo.",
  item: {
    vat: "IVA {vat}%",
    edit: "Modifica",
    delete: "Elimina",
  },
  footer: {
    selected: "{count} selezionato | {count} selezionati",
    createInvoice: "Crea fattura con questi",
    addToInvoice: "Aggiungi alla fattura",
  },
  form: {
    editTitle: "Modifica servizio",
    newTitle: "Nuovo servizio",
    subtitle: "Elemento riutilizzabile per le tue fatture",
    photoLabel: "Foto",
    optional: "facoltativo",
    uploadPhoto: "Carica",
    nameLabel: "Nome",
    namePlaceholder: "es. Pulizia finale",
    categoryLabel: "Categoria",
    categoryPlaceholder: "es. Pulizia",
    priceLabel: "Prezzo",
    vatLabel: "IVA",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Dettaglio mostrato sulla fattura",
    cancel: "Annulla",
    save: "Salva modifiche",
    create: "Crea servizio",
  },
  toasts: {
    loadError: "Impossibile caricare i servizi.",
    photoError: "Impossibile caricare la foto.",
    updated: "Servizio aggiornato.",
    created: "Servizio creato.",
    saveError: "Impossibile salvare il servizio.",
    deleteError: "Impossibile eliminarlo.",
  },
  confirmDelete: 'Eliminare "{name}" dal catalogo?',
};
